<template>
  <DeepDialog
    v-bind="$attrs"
    v-model="model"
    icon="far fa-info-circle"
    :max-width="350"
    persistent
    title="DeepBox INFO"
  >
    <template #content>
      <v-row>
        <v-col cols="12">
          <v-list>
            <v-list-item
              v-for="item in items"
              :key="item.title"
              :prepend-icon="item.icon"
              slim
              :title="item.title"
            >
              <template #subtitle>
                <DeepTextCopyToClipboard
                  show-on-hover
                  :text="item.valueToCopy ? item.valueToCopy : item.value"
                  @copied="toast.success(t('toast.success.copy_value'))"
                  @failed="toast.error(t('toast.error.copy_value'))"
                >
                  {{ item.value }}
                </DeepTextCopyToClipboard>
              </template>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </template>
  </DeepDialog>
</template>

<script lang="ts" setup>
import { toast } from 'vue-sonner'
import { DeepDialog, DeepTextCopyToClipboard } from '@deepcloud/deep-ui-lib'
import { formatDateTimeByDefaultFormat } from '@deepcloud/deep-ui-utils/date'
import { useKeycloak } from '@/composables/auth/keycloak.ts'

const model = defineModel({ type: Boolean, default: false })

const { bearer } = useKeycloak()
const { t } = useI18n()

const items = computed(() => [
  {
    title: 'Environment',
    icon: 'far fa-code',
    value: import.meta.env.VITE_ENVIRONMENT,
  },
  {
    title: 'Tag',
    icon: 'far fa-tag',
    value: import.meta.env.VITE_RELEASE_TAG,
  },
  {
    title: 'Datetime',
    icon: 'far fa-clock',
    value: formatDateTimeByDefaultFormat(import.meta.env.VITE_RELEASE_DATETIME),
  },
  {
    title: 'Commit ID',
    icon: 'far fa-code-commit',
    value: import.meta.env.VITE_RELEASE_COMMIT_ID,
  },
  {
    title: 'Auth Token',
    icon: 'far fa-coin',
    value: bearer.value ? `${bearer.value?.substring(0, 20)}...` : '',
    valueToCopy: bearer.value,
  },
])
</script>
